import { defineElement, FC, onDidLoad } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { Image } from '@atoms/image';
import { BPDFunctionalSvg } from '@atoms/svg/svg';
import { AREA_PICKER_MODAL_ID } from '@constants/modals';
import { ModalWrapper } from '@source/components/atoms/modal-wrapper/modal-wrapper';
import { useTranslate } from '@source/utilities/hooks';
import { getUserAreas, UserAreaProject, userStore } from '@store/user';
import { GTMPush } from '@utilities/gtm';

const SitePickerModal: FC = ({ element }) => {
    let userAreas: UserAreaProject[] | undefined = undefined;

    onDidLoad(() => {
        userStore.subscribe(render, ['loggedIn']);
        render();
    });

    const handleGtm = (data: { eventLabel: string }) => {
        GTMPush({
            event: 'areaSwitch',
            eventCategory: 'Gebieden',
            eventAction: 'Verandert',
            eventLabel: data.eventLabel,
        });
    };

    const areaPickerItemMapper = ({ Name, RedirectUrl, Id, LogoUrl }: UserAreaProject) => (
        <li class="site-picker-modal__list-item">
            <a
                href={RedirectUrl}
                class="site-picker-modal__list-item-inner"
                onClick={() => handleGtm({ eventLabel: Name })}>
                <div class="site-picker-modal__list-item-image-wrapper">
                    <Image
                        classes="site-picker-modal__list-item-image"
                        image={LogoUrl}
                        alt={`${Name} Logo`}
                        preload={{ width: 100 }}
                        objectFit={'contain'}
                    />
                </div>
                <span class="u-body-normal u-color--grey-50 u-flex-grow">{Name}</span>
                {Id === window.__ENVIRONMENT_DETAILS__.areaId ? (
                    <BPDFunctionalSvg name="icons-checkmark" />
                ) : null}
            </a>
        </li>
    );

    function render() {
        element.innerHTML = '';

        userAreas = getUserAreas();
        if (userAreas && userAreas.length > 1) {
            element.append(
                <ModalWrapper
                    id={AREA_PICKER_MODAL_ID}
                    active={false}
                    title={useTranslate('MyInterests')}
                    classes="site-picker-modal__wrapper"
                    noPadding>
                    <ul class="site-picker-modal__list">{userAreas?.map(areaPickerItemMapper)}</ul>
                </ModalWrapper>,
            );
        }
    }
};

defineElement('bpd-site-picker-modal', SitePickerModal);
